export const INFORMATION_CONSTS = {
    GET_INFORMATION_SLIDERS: "GET_INFORMATION_SLIDERS",
    CREATE_INFORMATION_SLIDER: "CREATE_INFORMATION_SLIDER",
    UPDATE_INFORMATION_SLIDERS_POSITIONS: "UPDATE_INFORMATION_SLIDERS_POSITIONS",
    UPDATE_INFORMATION_SLIDER_BY_ID: "UPDATE_INFORMATION_SLIDER_BY_ID",
    DELETE_INFORMATION_SLIDER_BY_ID: "DELETE_INFORMATION_SLIDER_BY_ID",

    SET_INFORMATION_DATA:"SET_INFORMATION_DATA",
};
